import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [phoneRevealed, setPhoneRevealed] = useState(false);

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-12">
          <div className="flex items-center mb-8 md:mb-0">
            <Logo className="h-12 w-12 mr-3" />
            <span className="text-2xl font-bold tracking-tight">Apex DSC</span>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/get-quote" className="text-gray-400 hover:text-white transition-colors">Get a Quote</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Services</h3>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">Tank Inspections</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">Monthly Walkthroughs</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">Compliance Assistance</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">Alarm Diagnostics</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center text-gray-400">
                <svg className="w-5 h-5 mr-2 text-primary-light flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                {phoneRevealed ? (
                  <a href="tel:+19414046083" className="hover:text-white transition-colors">(941) 404-6083</a>
                ) : (
                  <button onClick={() => setPhoneRevealed(true)} className="text-primary-light hover:text-white transition-colors cursor-pointer">
                    Click to reveal
                  </button>
                )}
              </div>
              <Link to="/contact" className="flex items-center text-gray-400 hover:text-white transition-colors">
                <svg className="w-5 h-5 mr-2 text-primary-light" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                Send us a message
              </Link>
              <p className="flex items-center text-gray-400">
                <svg className="w-5 h-5 mr-2 text-primary-light" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Mon–Fri: 8:00 AM – 5:00 PM
              </p>
            </div>
          </div>
          
          <div className="md:col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-white">Service Areas</h3>
            <p className="text-gray-400 mb-2">We proudly serve:</p>
            <div className="grid grid-cols-2 gap-1">
              <Link to="/regulations/georgia" className="bg-gray-800 px-3 py-1 rounded text-sm text-gray-300 hover:text-white hover:bg-gray-700 transition-colors">Georgia</Link>
              <Link to="/regulations/florida" className="bg-gray-800 px-3 py-1 rounded text-sm text-gray-300 hover:text-white hover:bg-gray-700 transition-colors">Florida</Link>
              <Link to="/regulations/south-carolina" className="bg-gray-800 px-3 py-1 rounded text-sm text-gray-300 hover:text-white hover:bg-gray-700 transition-colors">South Carolina</Link>
              <Link to="/regulations/north-carolina" className="bg-gray-800 px-3 py-1 rounded text-sm text-gray-300 hover:text-white hover:bg-gray-700 transition-colors">North Carolina</Link>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <p className="text-sm text-gray-400 text-center">
            &copy; {currentYear} Apex Diesel Storage Compliance. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
